import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CreditExceptionTaskResponse} from '../tasks/credit-exception-task-response';
import {OrderCancelTaskResponse} from '../tasks/order-cancel-task-response';
import {SfrComplexityTaskResponse} from '../tasks/sfr-complexity-task-response';
import {TaskResponse} from '../tasks/task-response';
import {TaxStatusResponse} from '../tasks/tax-status-response';
import {GoogleService} from './google-service';

@Service()
export class TaskResponseService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public orderCancel(id: number, response: OrderCancelTaskResponse): Observable<string> {
    let url = this.urlBase + 'taskResponse/orderCancel/' + id;
    let body = JSON.stringify(response);
    return this.postResponse(url, body);
  }

  private postResponse(url: string, body: string): Observable<string> {
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public sfrComplexity(id: number, response: SfrComplexityTaskResponse): Observable<string> {
    let url = this.urlBase + 'taskResponse/sfrComplexity/' + id;
    let body = JSON.stringify(response);
    return this.postResponse(url, body);
  }

  public creditExceptions(id: number, response: CreditExceptionTaskResponse): Observable<string> {
    let url = this.urlBase + 'taskResponse/creditExceptions/' + id;
    let body = JSON.stringify(response);
    return this.postResponse(url, body);
  }

  public partsShipDate(id: number, response: TaskResponse): Observable<string> {
    let url = this.urlBase + 'taskResponse/partsShipDate/' + id;
    let body = JSON.stringify(response);
    return this.postResponse(url, body);
  }

  public taxStatusRequest(id: number, response: TaxStatusResponse): Observable<string> {
    let url = this.urlBase + 'taskResponse/taxStatusRequest/' + id;
    let body = JSON.stringify(response);
    return this.postResponse(url, body);
  }

  public closeTask(taskResponse: TaskResponse): Observable<string> {
    const url = this.urlBase + 'taskResponse/closeTask';
    const body = JSON.stringify(taskResponse);
    return this.postResponse(url, body);
  }

}
